import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Returns_ds_get_scanned_material_detailsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { gtin: string, lotNumber: string, serialNumberCode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, VendorLots?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, SerialNumbers?: { Id?: number, LookupCode?: string }[] }[] }[], PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (isNil(inParams.lotNumber)) {
      missingRequiredInParams.push('\'lotNumber\'');
    }
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_scanned_material_details/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { gtin: string, lotNumber: string, serialNumberCode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, VendorLots?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, SerialNumbers?: { Id?: number, LookupCode?: string }[] }[] }[], PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (isNil(inParams.lotNumber)) {
      missingRequiredInParams.push('\'lotNumber\'');
    }
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_scanned_material_details/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { gtin: string, lotNumber: string, serialNumberCode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ProjectId?: number, VendorLots?: { Id?: number, ExpirationDate?: string, LookupCode?: string, Lots?: { Id?: number, LookupCode?: string, StatusId?: number, SerialNumbers?: { Id?: number, LookupCode?: string }[] }[] }[], PackagingLookups?: { PackagingId?: number, IsBasePackaging?: boolean }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.gtin)) {
      missingRequiredInParams.push('\'gtin\'');
    }
    if (isNil(inParams.lotNumber)) {
      missingRequiredInParams.push('\'lotNumber\'');
    }
    if (isNil(inParams.serialNumberCode)) {
      missingRequiredInParams.push('\'serialNumberCode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Returns/datasources/ds_get_scanned_material_details/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      gtin: string, lotNumber: string, serialNumberCode: string    }) {
        if(isNil(inParams.gtin)) {
          return true; 
        }
        if(isNil(inParams.lotNumber)) {
          return true; 
        }
        if(isNil(inParams.serialNumberCode)) {
          return true; 
        }
      return false;
    }
}
